import { composeCallbackUrl } from './redirectUrl'

export const buildMerchantCallbackUrl = (baseUrl: string, relativeCallbackUrl: string, queryArgs: string): string | undefined => {
  const url = composeCallbackUrl(baseUrl, relativeCallbackUrl)
  if (url === undefined || !queryArgs) return url
  const separator = url.includes('?') ? '&' : '?'
  const normalizedArgs = queryArgs.replace(/^[?&]/, '')
  return `${url}${separator}${normalizedArgs}`
}
